import { createSelector } from 'reselect';
import { EVENTS } from '../constants/event.constants';
import { initialState } from '../reducers/event.reducer';

const selectState = state => state?.[EVENTS] || initialState;

const selectEventsData = createSelector(
	selectState,
	state => state.get('data')
);

const selectEventsList = createSelector(
	selectEventsData,
	data => data.toList()
);

export const selectEvents = createSelector(
	selectEventsList,
	events => events.sortBy(a => -a.get('id'))
);

export const selectEventsFetched = createSelector(
	selectState,
	state => state.get('fetched')
);

export const selectOpenEvents = createSelector(
	selectEvents,
	events => events.filter(a => a.isOpen)
);